"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lifeVibesPointDelete = lifeVibesPointDelete;
exports.lifeVibesPointInfo = lifeVibesPointInfo;
exports.lifeVibesPointList = lifeVibesPointList;
exports.lifeVibesPointSave = lifeVibesPointSave;
exports.lifeVibesPointUpdate = lifeVibesPointUpdate;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 烟火点位分页列表
 */
function lifeVibesPointList(params) {
  var query = {
    page: params.page,
    limit: params.limit
  };
  if (params.keywords) query.keywords = params.keywords;
  if (params.pointType !== '' && params.pointType !== null && params.pointType !== undefined) {
    query.pointType = params.pointType;
  }
  if (params.provinceCode) query.provinceCode = params.provinceCode;
  if (params.cityCode) query.cityCode = params.cityCode;
  if (params.districtCode) query.districtCode = params.districtCode;
  if (params.lng !== '' && params.lng !== null && params.lng !== undefined) query.lng = params.lng;
  if (params.lat !== '' && params.lat !== null && params.lat !== undefined) query.lat = params.lat;
  if (params.maxDistance !== '' && params.maxDistance !== null && params.maxDistance !== undefined) {
    query.maxDistance = params.maxDistance;
  }
  return (0, _request.default)({
    url: '/admin/platform/life_vibes_point/list',
    method: 'get',
    params: query
  });
}

/**
 * 烟火点位详情
 */
function lifeVibesPointInfo(id) {
  return (0, _request.default)({
    url: '/admin/platform/life_vibes_point/info',
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 新增烟火点位
 */
function lifeVibesPointSave(data) {
  return (0, _request.default)({
    url: '/admin/platform/life_vibes_point/save',
    method: 'post',
    data: data
  });
}

/**
 * 更新烟火点位
 */
function lifeVibesPointUpdate(data) {
  return (0, _request.default)({
    url: "/admin/platform/life_vibes_point/update?id=".concat(data.id),
    method: 'post',
    data: data
  });
}

/**
 * 删除烟火点位
 */
function lifeVibesPointDelete(id) {
  return (0, _request.default)({
    url: '/admin/platform/life_vibes_point/delete',
    method: 'get',
    params: {
      id: id
    }
  });
}